import React from 'react';
import SocialLinks from 'components/info/SocialLinks';  // Le composant SocialLinks
import AlloMairie from 'components/info/AlloMairie';
import ContactInfo from 'components/info/ContactInfo';
import UrgenceNumbers from 'components/info/UrgenceNumbers';
import MetaFooter from 'components/info/MetaFooter';
import styles from './Footer.module.css';  // Fichier CSS pour le Footer
import { useSubSite } from 'contexts/SubSiteContext'; // Hook pour vérifier le sous-site
import useDesignSettingsData from 'hooks/useDesignSettingsData';
import useFooterData from 'hooks/useFooterData';
import Spinner from 'components/common/Spinner'

const Footer = ({ forceMainSite = false }) => {

  const { isSubSite, subSiteSlug } = useSubSite();
  const { designSettings, settingsLoading } = useDesignSettingsData({ forceMainSite });
  const { footerData } = useFooterData(isSubSite, forceMainSite ? null : subSiteSlug);

  const logoSrc = designSettings?.websiteLogoForFooter;

  if (settingsLoading) return <div><Spinner /></div>;

  return (
    <footer>

      {isSubSite ? (
        <div className={`global-section ${styles.altFooter}`}>
          <div className={`global-container ${styles.container}`}>
            <div className={styles.socials}>
              <figure>
                {logoSrc && (
                  <img src={logoSrc} alt="Logo du site" />
                )}
              </figure>

              <SocialLinks />

            </div>

            <ContactInfo footerData={footerData} />
            <AlloMairie footerData={footerData} />
            <UrgenceNumbers />

          </div>

          <MetaFooter />

        </div>

      ) : (
        <div className={`global-section ${styles.footer}`}>
          <div className={`global-container ${styles.container}`}>
            <div className={styles.socials}>
              <figure>
                {logoSrc && (
                  <img src={logoSrc} alt="Logo de la ville d'Arras" />
                )}
              </figure>

              <SocialLinks />

            </div>

            <ContactInfo footerData={footerData}/>
            <AlloMairie footerData={footerData} />
            <UrgenceNumbers />

          </div>

          <MetaFooter />

        </div>
      )}

    </footer>
  );
};

export default Footer;
